import { formilyReact } from '@/form/formily';
import { componentMap } from '@/form/component-map';
export var createScope = function (scope) {
    if (scope) {
        return formilyReact.createSchemaField({
            components: componentMap,
            scope: scope,
        });
    }
    else {
        return formilyReact.createSchemaField({
            components: componentMap,
        });
    }
};
export var SchemaField = createScope();
